<template>
    <h1>Page not found. Get back to <router-link to="/">Home</router-link></h1>
</template>
